// extracted by mini-css-extract-plugin
export default {"mainContainer":"Documentation_mainContainer__6IIX2","leftCol":"Documentation_leftCol__BHGvh","title":"Documentation_title__vMPVL"};